<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <div class="error-box">
    <div class="error-box__inner">
      <div class="error-box__inner__title">{{ title }}</div>
      <div class="error-box__inner__message" v-if="message">{{ message }}</div>
      <slot />
      <img :src="logoSrc" alt="logo" v-if="logo" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-box {

  &__inner {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 4em;
    margin-bottom: 4em;

    &__title {
      font-size: 180%;
      font-weight: bold;
    }

    &__message {
      margin-top: 1em;
      margin-bottom: 1em;
    }

    img {
      max-width: 300px;
      margin-top: 4em;
      margin-bottom: 4em;
    }
  }
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Error'
    },
    logo: {
      type: Boolean,
      default: true
    },
    message: String
  },
  computed: {
    logoSrc: () => require('../assets/logo.svg')
  }
}
</script>
